// extracted by mini-css-extract-plugin
module.exports = {"container":"Provinces_container__2Q6Oo","directory":"Provinces_directory__98z-_","content":"Provinces_content__1f__d"};